export enum Gender {
  Male = 'male',
  Female = 'female',
}

export class Student {
  _id?: string;
  profileImgUrl: string;
  name: string;
  surname: string;
  phone: string;
  email: string;
  gender = Gender.Male;
  balance = 0;
  coursesCompleted = 0;
  coursesEnrolled = 0;
  lastActiveDate = new Date();
  createdDate = new Date();
  updatedDate = new Date();
  examResults: any = [];
  availableCourses: any = [];
  availableSubjectTests: any = [];
  availableExamsList: AvailableExam[] = [];
}

export class AvailableExam {
  examId: string;
  mathBasic: number = DefaultExamTries;
  mathAdvanced: number = DefaultExamTries;
  analogiya: number = DefaultExamTries;
  grammar: number = DefaultExamTries;
  okuuTushunuu: number = DefaultExamTries;
}

export const DefaultExamTries = 3;
